import type {
  SignInSubmitDataModel,
  SignInRequestDto,
  SignInResponseModel,
  SignInResponseDto,
} from './model';

export const modelToDto = ({ email, loginId }: SignInSubmitDataModel): SignInRequestDto => ({
  email,
  login_id: loginId,
});

// eslint-disable-next-line camelcase
export const dtoToModel = ({ next_url }: SignInResponseDto): SignInResponseModel => ({
  // eslint-disable-next-line camelcase
  nextUrl: next_url,
});
